import React from "react";
import { Phone } from "lucide-react";
import { companyInfo } from "../data/mock";

const CallButton = () => {
  return (
    <a
      href={`tel:${companyInfo.emergencyPhone.replace(/\s/g, "")}`}
      data-testid="floating-call-button"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#C9A227] text-black font-bold px-5 py-3.5 rounded-full shadow-lg animate-call-blink hover:scale-105 transition-transform"
    >
      <Phone className="w-5 h-5" />
      <span>Appeler</span>
    </a>
  );
};

export default CallButton;
